import React, { useState, useContext } from "react";
// React Bootstrap
import { Button, Carousel, Image } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
// Contexto
import { ConfirmModalContext } from "../../context/confirmModalContext";

const ImageWrapper = styled.div`
  height: 20rem;
`;

const CustomImg = styled(Image)`
  object-fit: contain;
  height: 100%;
`;

const CustomCarousel = styled(Carousel)`
  .carousel-caption {
    color: black;
  }
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    filter: invert(1) grayscale(100);
  }
  li {
    background-color: #000;
  }
`;

const Delete = styled(Button)`
  width: 27px;
  height: 27px;
  position: absolute;
  top: 94%;
  right: 48.7%;
  padding: 0;
`;

const Galeria = ({ images = [], deleteFunction, ...props }) => {
  const [index, setIndex] = useState(0);
  // Ventana confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return images.length ? (
    <CustomCarousel activeIndex={index} onSelect={handleSelect} interval={null}>
      {images.map((img) => {
        return (
          <Carousel.Item key={img.id}>
            <ImageWrapper>
              <CustomImg className="d-block w-100" src={img.src} alt={img.name} />
              {deleteFunction && (
                <Delete
                  onClick={() => {
                    confirmModalSetTitle(`Eliminar imagen`);
                    confirmModalSetContent(<p> {"¿Está seguro de que quiere eliminarla?"} </p>);
                    confirmModalSetFunction(() => {
                      deleteFunction(img.id);
                      // Gestión del indice de la imagen
                      index !== 0 && setIndex(index - 1);
                    });
                    confirmModalSetShow(true);
                  }}
                  variant="light"
                >
                  <Image width="20" fluid src="/svg/trash-outline.svg" />
                </Delete>
              )}
            </ImageWrapper>
            {/* El estilo position initial sobreescribe los estilos de boostrap para colocar el texto debajo de la imagen en vez de sobre la imagen */}
            <Carousel.Caption style={{ position: "initial" }} className="mt-2">
              <span>
                <h3>{img.name}</h3>
                <p>{img.description}</p>
              </span>
            </Carousel.Caption>
          </Carousel.Item>
        );
      })}
    </CustomCarousel>
  ) : (
    <p>No hay fotos aún en la galería</p>
  );
};

export default Galeria;
